// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".actions[data-v-4d5aaf55]  .menu-wrap{left:0!important;min-width:240px}.actions-activator[data-v-4d5aaf55]{cursor:pointer}.action-item[data-v-4d5aaf55]:hover{background-color:#f9c961}", ""]);
// Exports
module.exports = exports;
